/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable  @typescript-eslint/no-unused-vars */
import {Component, DestroyRef, DoCheck, OnDestroy, OnInit} from '@angular/core';
import {PlanModelService} from '../../common/service/plan-model.service';
import {isArrayDifferent, isDefined, isUndefined} from '../../common/service/data-util';
import {NgClass} from '@angular/common';
import {ControlContainer, FormsModule, NgForm} from '@angular/forms';
import {NlrTypeheadDirective} from '../../common/directive/nlr-typehead.directive';
import {debounceTime, distinctUntilChanged, map, Observable} from 'rxjs';
import {MessageService} from '../../common/service/message.service';
import {HttpClient} from '@angular/common/http';
import {StrataSurveyDetails} from '../../common/models/strata-survey-details.model';
import {NgEventBus} from 'ng-event-bus';
import {Road} from '../../common/models/road.model';
import {LookupService} from '../../common/service/lookup.service';
import {AppConfigService} from '../../common/service/app-config.service';
import {PATTERNS} from '../../common/constants';
import {NlrHasPermissionsPipe} from '../../common/pipe/nlr-has-permissions.pipe';
import {NlrPermissionsDisabledPipe} from '../../common/pipe/nlr-permissions-disabled-pipe';
import {NlrPatternDirective} from '../../common/directive/nlr-pattern.directive';
import {NlrFormFieldHasErrorPipe} from '../../common/pipe/nlr-form-field-has-error.pipe';
import {PlanTypeLookup} from '../../common/models/plan-type.model';
import {PlanPurposeLookup} from '../../common/models/plan-purpose.model';
import {UiConfigurationService} from '../../common/service/ui-configuration.service';
import {MaxLengthInputLimitDirective} from '../../common/directive/max-length-input-limit.directive';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
    selector: 'nlr-strata-schema-details',
    imports: [
        NgClass,
        FormsModule,
        NlrTypeheadDirective,
        NlrHasPermissionsPipe,
        NlrPermissionsDisabledPipe,
        NlrPatternDirective,
        NlrFormFieldHasErrorPipe,
        MaxLengthInputLimitDirective
    ],
    templateUrl: './strata-schema-details.component.html',
    styleUrl: './strata-schema-details.component.scss',
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class StrataSchemaDetailsComponent implements OnInit, DoCheck, OnDestroy {
    private hasManagementStatement: boolean = false;
    private hasSchemeVacantLot: boolean = false;
    private hasSchemeName: boolean = false;
    get readonly() {
        return this.planModelService.readonly;
    }

    STRATA_ROAD_PREPOP = 'PREPOP';

    title = 'Scheme details';
    roads: Road[] = [];

    schemeTierValues = [
        {id: 'SINGLE', displayValue: 'Single tier'},
        {id: 'MULTIPLE', displayValue: 'Multiple Tiers'}
    ];

    vacantStrataLotValues = [
        {id: true, displayValue: 'Yes', active: true},
        {id: false, displayValue: 'No', active: true}
    ];

    managementStatementExists = [
        {id: true, displayValue: 'Yes', active: true},
        {id: false, displayValue: 'No', active: true}
    ];

    managementStatementKey = 'management-statement-exists.prompt';
    schemeNameKey = 'scheme.name.label.app';
    schemeVacantLotKey = 'scheme.vacant-lot.label.app';

    strataName = '';
    strataNameEnabled = true;
    planNumber = undefined;
    roadNumber = undefined;
    roadName = '';
    roadNumber2 = undefined;
    roadName2 = '';
    isRoadTwoSelected: boolean;
    isRoadOneSelected: boolean;
    planType: PlanTypeLookup = undefined;
    planPurpose: PlanPurposeLookup = undefined;
    formerTenures: any[] = undefined;
    localities: any[] = undefined;
    lgas: any[] = undefined;

    documentPattern = PATTERNS.DOCUMENT_PATTERN;

    constructor(
        private planModelService: PlanModelService,
        private messageService: MessageService,
        private lookupService: LookupService,
        private http: HttpClient,
        private eventBus: NgEventBus,
        private appConfigService: AppConfigService,
        private uiConfigurationService: UiConfigurationService,
        private destroyRef: DestroyRef
    ) {}

    ngDoCheck(): void {
        if (
            this.getModel().planType !== this.planType ||
            this.getModel().planNumber !== this.planNumber ||
            this.getModel().planPurpose !== this.planPurpose ||
            isArrayDifferent(this.getModel().formerTenures, this.formerTenures) ||
            isArrayDifferent(this.getModel().localities, this.localities) ||
            isArrayDifferent(this.getModel().localGovernmentAuthorities, this.lgas)
        ) {
            this.planType = this.getModel().planType;
            this.planNumber = this.getModel().planNumber;
            this.planPurpose = this.getModel().planPurpose;
            this.formerTenures = this.getModel().formerTenures;
            this.localities = [...this.getModel().localities];
            this.lgas = [...this.getModel().localGovernmentAuthorities];
            if (this.getModel().planPurpose.strataRoad === 'PREPOP') {
                this.loadStrataDetails();
            }
            this.retrieveStrataRoads();
            this.refreshFlags();
        }
    }

    ngOnInit(): void {
        if (isUndefined(this.getModel().strata)) {
            this.getModel().strata = {
                parcelAddressRoadName: {displayName: ''},
                parcelAddressRoadName2: {displayName: ''}
            };
        }
        this.init();
        this.eventBus
            .on('nlr:trait-service:traitsChanged')
            .pipe(debounceTime(200), distinctUntilChanged(), takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                this.refreshFlags();
            });
    }

    getModel() {
        return this.planModelService.getModel();
    }

    getStrata() {
        return this.getModel().strata;
    }

    getParcelAddressRoadName2() {
        if (this.getStrata().parcelAddressRoadName2?.displayName) {
            return this.getStrata().parcelAddressRoadName2;
        } else {
            this.getStrata().parcelAddressRoadName2 = {
                displayName: ''
            };
            return this.getStrata().parcelAddressRoadName2;
        }
    }

    getParcelAddressRoadName() {
        if (this.getStrata().parcelAddressRoadName?.displayName) {
            return this.getStrata().parcelAddressRoadName;
        } else {
            this.getStrata().parcelAddressRoadName = {
                displayName: this.roadName
            };
            return this.getStrata().parcelAddressRoadName;
        }
    }
    retrieveStrataSchemeDetails() {
        const url =
            this.appConfigService.settings.apiGatewayUrl +
            '/strata/findBySurveyTypeAndPlanNumber/' +
            this.getModel().planType.smpId +
            '/' +
            this.getModel().planNumber;
        return this.http.get<StrataSurveyDetails>(url, {transferCache: false});
    }
    roadsSearch: (text$: Observable<string>) => Observable<string[]> = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map(term =>
                term.length < 1
                    ? []
                    : this.roads
                          .filter(r => r.displayName.toLowerCase().indexOf(term.toLowerCase()) > -1)
                          .map(r => r.displayName)
                          .slice(0, 10)
            )
        );

    isStrataNameEnabled() {
        return this.strataNameEnabled;
    }

    loadStrataDetails() {
        this.planNumber = this.getModel().planNumber;
        this.retrieveStrataSchemeDetails().subscribe({
            next: response => {
                if (response) {
                    this.strataName = response.buildingName;

                    // populate the road details
                    this.roadNumber = response.roadNumber;
                    if (response.roadName != null) {
                        this.roadName = response.roadName.trim();
                    } else {
                        this.roadName = response.roadName;
                    }
                    this.roadNumber2 = response.roadNumber2;
                    this.roadName2 = response.roadName2 != null ? response.roadName2 : '';
                } else {
                    this.strataName = '';
                    this.roadNumber = undefined;
                    this.roadName = '';
                    this.roadNumber2 = undefined;
                    this.roadName2 = '';
                }
                this.updateModel();
            },
            error: error => {
                console.error('load strata details failed ' + error.message);
            }
        });
    }

    updateModel() {
        const planModel = this.getModel();
        const planPurpose = planModel.planPurpose;
        if (!planPurpose) {
            return;
        }

        if (!planModel.strata) {
            planModel.strata = {};
        }

        const strata = planModel.strata;

        if (planPurpose.schemeTiers) {
            // default the scheme tiers
            if (!strata.schemeTiers) {
                strata.schemeTiers = 'SINGLE';
            }

            if (planPurpose.mergerPerScheme) {
                strata.priorMergerApproved = strata.priorMergerApproved || false;
            } else {
                strata.priorMergerApproved = undefined;
            }
        } else {
            // Strata Survey Plan
            strata.schemeTiers = undefined;
            strata.priorMergerApproved = undefined;
        }
        if (planPurpose.strataRoad === this.STRATA_ROAD_PREPOP) {
            strata.parcelAddressRoadNumber = strata.parcelAddressRoadNumber ? strata.parcelAddressRoadNumber : this.roadNumber;
            strata.parcelAddressRoadName = strata.parcelAddressRoadName
                ? strata.parcelAddressRoadName
                : isDefined(this.roadName)
                  ? {displayName: this.roadName}
                  : {displayName: ''};
            strata.parcelAddressRoadNumber2 = strata.parcelAddressRoadNumber2
                ? strata.parcelAddressRoadNumber2
                : strata.parcelAddressRoadNumber2
                  ? strata.parcelAddressRoadNumber2
                  : this.roadNumber2;
            strata.parcelAddressRoadName2 = strata.parcelAddressRoadName2
                ? strata.parcelAddressRoadName2
                : isDefined(this.roadName2)
                  ? {displayName: this.roadName2}
                  : {displayName: ''};

            this.strataNameEnabled = false;
            strata.strataName = this.strataName;
        } else {
            strata.parcelAddressRoadNumber = undefined;
            strata.parcelAddressRoadName = isDefined(this.roadName) ? {displayName: this.roadName} : {displayName: ''};
            strata.parcelAddressRoadNumber2 = undefined;
            strata.parcelAddressRoadName2 = isDefined(this.roadName2) ? {displayName: this.roadName2} : {displayName: ''};
            strata.strataName = undefined;
            this.strataNameEnabled = true;
        }
        this.refreshFlags();
    }

    set strataNameValue(value: string) {
        this.getStrata().strataName = value;
    }

    get strataNameValue() {
        return this.getStrata()?.strataName;
    }

    roadOneChanged(event: string) {
        if (isUndefined(event)) {
            this.isRoadOneSelected = false;
        }
        this.isRoadOneSelected = this.roads.filter(r => r.displayName.toLowerCase() == event.toLowerCase()).length > 0;
    }

    roadOneSelected(event) {
        this.isRoadOneSelected = true;
    }

    roadTwoChanged(event: string) {
        if (isUndefined(event)) {
            this.isRoadTwoSelected = false;
        }
        this.isRoadTwoSelected = this.roads.filter(r => r.displayName.toLowerCase() == event.toLowerCase()).length > 0;
    }

    roadTwoSelected(event: string) {
        this.isRoadTwoSelected = true;
    }

    displayComponent(messageKey, strataModelKey) {
        const isMessageDefined = this.messageService.isMessageDefined(messageKey);
        if (isMessageDefined === undefined) {
            return false;
        }
        if (isMessageDefined) {
            return true;
        }
        const planModel = this.getModel();
        if (planModel.strata) {
            delete planModel.strata[strataModelKey];
        }
        return false;
    }

    displayManagementStatement() {
        return this.hasManagementStatement;
    }

    displaySchemeVacantLot() {
        return this.hasSchemeVacantLot;
    }

    displaySchemeName() {
        return this.hasSchemeName;
    }

    retrieveStrataRoads() {
        console.debug(this.title + ' controller checking locality by watch!');

        if (!this.getModel().strata) {
            this.getModel().strata = {};
        }

        const {localities, localGovernmentAuthorities, strata} = this.getModel();
        strata.lga = localGovernmentAuthorities && localGovernmentAuthorities.length ? localGovernmentAuthorities[0].lgaName : '';
        strata.locality = localities && localities.length ? localities[0].localityName : '';
        if (strata.locality) {
            const subs = this.lookupService.retrieveLookup<Road[]>(`/locationname/findAllRoadsByLocality/${strata.locality}`).subscribe({
                next: data => {
                    this.roads = data;
                },
                error: error => {
                    console.error('Road search failed ' + error.message);
                }
            });
            this.eventBus.cast('nlr:busy', subs);
        }
    }

    init() {
        if (
            isDefined(this.getModel().planType) &&
            isDefined(this.getModel().planNumber) &&
            isDefined(this.getModel().planPurpose) &&
            isDefined(this.getModel().formerTenures) &&
            this.getModel().formerTenures.length > 0 &&
            this.getModel().planPurpose.strataRoad === 'PREPOP'
        ) {
            this.loadStrataDetails();
            this.retrieveStrataRoads();
        }
    }

    ngOnDestroy() {
        const infoUiGroup = this.uiConfigurationService.getInfoUiGroup();
        if (!infoUiGroup?.strataSchemeDetailsDisplay) {
            this.getModel().strata = undefined;
        }
    }

    isRoadOneValid() {
        return this.isRoadOneSelected == undefined || this.isRoadOneSelected;
    }

    refreshFlags() {
        this.hasManagementStatement = this.displayComponent(this.managementStatementKey, 'managementStatementExists');
        this.hasSchemeVacantLot = this.displayComponent(this.schemeVacantLotKey, 'vacantStrataLot');
        this.hasSchemeName = this.displayComponent(this.schemeNameKey, 'strataName');
    }
}
